<template>
  <div class="ma-1 mt-5">
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card class v-else>
      <v-data-table
        dense
        :headers="headers"
        :items="roleDatalist"
        :options.sync="pagination"
        :items-per-page="itemsPerPage"
        @update:options="getRoleTableListPagination()"
        :search="search"
        :no-data-text="Nodata"
      >
        <template v-slot:top>
          <v-row>
            <v-spacer />
            <v-col cols="3" class="mt-6 ml-2">
              <v-text-field
                v-model="search"
                shaped
                outlined
                dense
                class="mt-n1"
                color="primary"
                append-icon="mdi-magnify"
                label="Search"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="1" class="mt-5 mr-4">
              <v-dialog persistent v-model="addRoles" width="600">
                <v-toolbar dark dense class="header">
                  <v-icon>mdi-plus</v-icon>
                  <span class="ml-3">Add Role</span>
                  <v-spacer></v-spacer>
                  <v-btn class text dark @click="addRoles = false">
                    <v-icon color="white" small>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <!-- <v-card>
                    <div
                      justify="center"
                      align="center"
                      class="font-weight-bold text mt-3 mb-2"
                      style="font-size: 13px"
                    >
                      <v-icon style="font-size: 13px" class="mr-1 mt-n1"
                        >info</v-icon
                      >Card Details are Listed Below and click on Continue for
                      other payment methods.
                    </div></v-card
                  > -->
                <template #activator="{ on: addRoles }">
                  <v-tooltip bottom color="primary">
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        rounded
                        class="navbar white--text mt-1"
                        v-on="{ ...addRoles, ...tooltip }"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text">Add New Role</span>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-divider></v-divider>
                  <v-form ref="formRole">
                    <v-row class="mt-8 mx-7">
                      <v-text-field
                        v-model="role_name"
                        label="Role Name *"
                        color="primary"
                        :rules="[
                          (v) => !!v || 'Required',
                          (v) =>
                            /^([a-zA-Z0-9 ]{0,85}$)[0-9 ]{0,85}$/.test(v) ||
                            'Invalid Input',
                          (v) =>
                            v.length <= 85 ||
                            'Role Name must be less than 25 characters',
                        ]"
                        @keydown.space="preventLeadingSpace"
                        required
                        maxlength="85"
                        outlined
                        dense
                      ></v-text-field>
                    </v-row>
                    <v-row class="mx-7">
                      <v-text-field
                        v-model="role_description"
                        color="primary"
                        :rules="numberrules"
                        label="Description *"
                        maxlength="100"
                        @keydown.space="preventLeadingSpace"
                        required
                        outlined
                        dense
                      ></v-text-field>
                    </v-row>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        rounded
                        class="elevation-6 primary white--text"
                        :loading="isLoading"
                        medium
                        @click="createRole"
                      >
                        Add
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ roleDatalist.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.role_name`]="{ item }">
          <span class="caption">{{ item.role_name }}</span>
        </template>
        <template v-slot:[`item.role_description`]="{ item }">
          <span class="caption">{{ item.role_description }}</span>
        </template>
        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption">{{ item.created_on }}</span>
        </template>
      </v-data-table>
    </v-card>

    <OverleyProccessg :overlay="overlay" />
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
//import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: { OverleyProccessg },
  data: () => ({
    checkaccessdata: {},
    isLoading: false,
    nameRules: [(v) => !!v || "Required"],
    numberrules: [
      (v) => !!v || "Required",
      (v) => v.length >= 5 || "Minimum 5 characters",
      (v) => v.length <= 100 || "Name must be less than 100 characters",
    ],
    role_description: "",
    role_name: "",
    addRoles: false,
    overlay: false,
    roleDatatable: [],
    AddUser: false,
    status: "",
    search: "",
    roleDatalist: [],
    Nodata: "",
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    headers: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "ROLE NAME",
        value: "role_name",
      },
      {
        text: "DESCRIPTION",
        value: "role_description",
      },
      {
        text: "CREATED ON",
        value: "created_on",
      },
    ],
  }),
  mounted() {
    this.checkaccess();
  },
  created() {
    this.getRoleTableList();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "SETTINGS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      this.checkaccessdata = responseData.data.data;
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },

    async createRole() {
      //alert(90);
      if (this.$refs.formRole.validate()) {
        this.isLoading = true;
        var inputData = {
          method_name: "SETTINGS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CROLES",
            role_name: this.role_name,
            role_description: this.role_description,
            corp_id: this.$store.getters.get_corpid,
          },
        };
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.clearData();
          this.getRoleTableList();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.clearData();
        }
        this.getRoleTableList();
      }
    },
    clearData() {
      this.addRoles = false;
      this.isLoading = false;
      this.$refs.formRole.reset();
      this.$refs.formRole.resetValidation();
    },

    async getRoleTableListPagination() {
      if (this.roleDatalist.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "SETTINGS",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GROLES",
            corp_id: this.$store.getters.get_corpid,
            search_text: "",
          },
        };

        var responseData = await apiCall(inputData);

        this.roleDatalist = this.roleDatalist.concat(responseData.data.data);
      }
    },

    async getRoleTableList() {
      //alert(90);
      this.overlay = true;
      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "GROLES",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      //  console.log("responseData", responseData.data.data);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.overlay = false;
          this.roleDatalist = responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.overlay = false;
        this.roleDatalist = [];
      }

      // this.$emit("backChild");
      // this.$store.commit("snackbar/showMessage", {
      //   content: "Acknowledged Proxy Numbers",
      //   color: "green"
      // });
      // this.ackdialog = false;
    },
  },
};
</script>

<style>
.greencolor {
  color: red;
}
.bluecolor {
  color: green;
}
.bluecolor:hover {
  cursor: pointer;
}
.orangecolor {
  color: orange;
}
.orangecolor:hover {
  cursor: pointer;
}
.clr:hover {
  cursor: pointer;
}
.clr {
  color: darkturquoise;
}

.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
